export default "__VITE_ASSET__CBNgccUz__"